import React, { lazy, Suspense } from 'react'
import { RouteLoading } from './RouteLoading'
import { FeatureFlagContextProvider } from '../../FeatureFlag'
import { WindowWidthContextProvider } from '../../WindowWidthContext'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router'
import { ScrollToTop } from './ScrollToTop'
import { TopLevelLanguageAndMeta } from '../i18n/TopLevelLanguageAndMeta'
import { LogoutListener } from './LogoutListener'

const ThessaApplication = lazy(() => import('../ThessaApplication'))
const ForgotPassword = lazy(() => import('../auth/ForgotPassword'))
const ResetPassword = lazy(() => import('../auth/ResetPassword'))
const Invitation = lazy(() => import('../invitation/Invitation'))
const ViewRoar = lazy(() => import('../roar/ViewRoar'))
const About = lazy(() => import('../about/About'))
const Contact = lazy(() => import('../help/Contact'))
const AccessibilityStatement = lazy(() => import('../accessibility-statement/AccessibilityStatement'))
const Sitemap = lazy(() => import('../sitemap/Sitemap'))

export const TopLevelRoutes = () => (
  <>
    <TopLevelLanguageAndMeta />
    <FeatureFlagContextProvider>
      <WindowWidthContextProvider>
        <BrowserRouter>
          <LogoutListener />
          <Suspense fallback={<RouteLoading />}>
            <ScrollToTop />
            <Routes>
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:email/:resetPasswordToken" element={<ResetPassword />} />
              <Route path="/invitations/:token" element={<Invitation />} />
              <Route path="/roar/:roarValidFrom?" element={<ViewRoar />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/accessibility-statement" element={<AccessibilityStatement />} />
              <Route path="/sitemap" element={<Sitemap />} />
              <Route path="/external-login" element={<Navigate to="/" replace />} />
              <Route path="/*" element={<ThessaApplication />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </WindowWidthContextProvider>
    </FeatureFlagContextProvider>
  </>
)
